export default "__VITE_ASSET__VpLFBnyr__"